<script lang="ts">
    import Fa from 'svelte-fa'
    import { faAngleLeft, faSave } from '@fortawesome/free-solid-svg-icons'
    import Content from '../_common/content.svelte'
    import ProspectAudienceSelect from './prospect-audience-select.svelte'
    import { createEventDispatcher } from 'svelte'
    import { SearchQueryRepository } from '../../modules/prospectApi/search-query/search-query.repository'
    import { SearchQueryService } from '../../modules/prospectApi/search-query/search-query.service'
    import type { CreateStaticAudienceDto } from '../../modules/prospectApi/search-query/create-static-audience.dto'
    import type { Audience } from '../../modules/eventsApi/audiences/audience'
    const dispatch = createEventDispatcher()

    const entityRep = new SearchQueryRepository()
    const entityS = new SearchQueryService(entityRep)

    export let businessId: string[]
    let audience: Audience

    async function saveAudience() {
        const dto: CreateStaticAudienceDto = {
            audienceId: audience.audienceId,
            businessId,
        }
        if (!validateDto(dto)) return
        const result = await entityS.add(dto)
        dispatch('close')
    }

    function validateDto(dto: CreateStaticAudienceDto) {
        if (!dto.audienceId) {
            evaluateError('Selecione a audiência')
            return false
        }
        if (dto.businessId.length === 0) {
            evaluateError('Você deve selecionar ao menos 1 item para enviar')
            return false
        }
        return true
    }

    function evaluateError(error) {
        window.error(error)
    }

    function close() {
        dispatch('close')
    }
</script>

<Content>
    <div class="grid-act">
        <div class="spacer" />
        <button class="btn btn-primary" on:click={saveAudience}><Fa icon={faSave} /> Salvar</button>
    </div>

    <div class="grid-form p-2">
        <div class="row">
            <div class="col-md-12">
                <div class="input-group">
                    <ProspectAudienceSelect bind:audience label="Selecione um público para adicionar" />
                </div>
            </div>
        </div>
    </div>
</Content>
